// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#widget-container .typing-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 1.25rem;
  padding-bottom: 1.25rem;
}

#widget-container .typing-bubble {
  border-radius: 0px 10px 10px 10px;
  background: #fff;
  box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  padding: 20px;
  align-items: center;
  gap: 10px;
}

#widget-container .dot {
  width: 8px;
  height: 8px;
  background-color: gray;
  border-radius: 50%;
  animation: typing-animation 1.5s infinite ease-in-out;
}

#widget-container .dot:nth-child(1) {
  animation-delay: 0s;
}

#widget-container .dot:nth-child(2) {
  animation-delay: 0.2s;
}

#widget-container .dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing-animation {
  0% {
    opacity: 0.3;
    transform: translateY(0px);
  }
  50% {
    opacity: 1;
    transform: translateY(-3px);
  }
  100% {
    opacity: 0.3;
    transform: translateY(0px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/loader/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,YAAY;IACZ,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,YAAY;IACZ,0BAA0B;EAC5B;AACF","sourcesContent":["#widget-container .typing-container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding-left: 1.25rem;\n  padding-bottom: 1.25rem;\n}\n\n#widget-container .typing-bubble {\n  border-radius: 0px 10px 10px 10px;\n  background: #fff;\n  box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.1);\n  display: flex;\n  padding: 20px;\n  align-items: center;\n  gap: 10px;\n}\n\n#widget-container .dot {\n  width: 8px;\n  height: 8px;\n  background-color: gray;\n  border-radius: 50%;\n  animation: typing-animation 1.5s infinite ease-in-out;\n}\n\n#widget-container .dot:nth-child(1) {\n  animation-delay: 0s;\n}\n\n#widget-container .dot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n#widget-container .dot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes typing-animation {\n  0% {\n    opacity: 0.3;\n    transform: translateY(0px);\n  }\n  50% {\n    opacity: 1;\n    transform: translateY(-3px);\n  }\n  100% {\n    opacity: 0.3;\n    transform: translateY(0px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
